import { registerModal } from 'features/Modal/ModalRegistry'
import NumbersEnableFlowsModal from './NumbersEnableFlowsModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'NUMBERS_ENABLE_FLOWS'
registerModal(modalType, NumbersEnableFlowsModal)

export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEnableFlowsModal/NumbersEnableFlowsModal.action.js